import { Platform } from 'react-native';
import Config from 'react-native-config';
import { KEY } from '../../types';
import * as types from './types';

export const GET_VISIT_TOKEN = `${KEY}.GET_VISIT_TOKEN`;
export const GET_VISIT_TOKEN_SUCCESS = `${KEY}.GET_VISIT_TOKEN_SUCCESS`;
export const GET_VISIT_TOKEN_FAIL = `${KEY}.GET_VISIT_TOKEN_FAIL`;

const appType = Platform.select({
  android: 'mobile',
  ios: 'mobile',
  web: 'web'
});

export const getVisitToken = (payload: types.GetVisitTokenPayload) => ({
  type: GET_VISIT_TOKEN,
  payload: {
    client: 'amwellAuthService',
    request: {
      method: 'post',
      url: Config.AMWELL_AUTH_SERVICE_URL_GET_VISIT_TOKEN,
      data: { appType, ...payload }
    }
  }
});

export const LOGIN = `${KEY}.LOGIN`;
export const LOGIN_SUCCESS = `${KEY}.LOGIN_SUCCESS`;
export const LOGIN_FAIL = `${KEY}.LOGIN_FAIL`;

export const login = (payload: types.LoginPayload) => ({
  type: LOGIN,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'login',
      data: payload
    }
  }
});

export const LOGIN_WITH_TOKEN = `${KEY}.LOGIN_WITH_TOKEN`;
export const LOGIN_WITH_TOKEN_SUCCESS = `${KEY}.LOGIN_WITH_TOKEN_SUCCESS`;
export const LOGIN_WITH_TOKEN_FAIL = `${KEY}.LOGIN_WITH_TOKEN_FAIL`;

export const loginWithToken = (payload: types.LoginWithTokenPayload) => ({
  type: LOGIN_WITH_TOKEN,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'loginWithToken',
      data: payload
    }
  }
});

export const LOGOUT = `${KEY}.LOGOUT`;
export const LOGOUT_SUCCESS = `${KEY}.LOGOUT_SUCCESS`;
export const LOGOUT_FAIL = `${KEY}.LOGOUT_FAIL`;

export const logout = () => ({
  type: LOGOUT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'logout'
    }
  }
});

export const UPDATE_CONSUMER_LEGAL_RESIDENCE = `${KEY}.UPDATE_CONSUMER_LEGAL_RESIDENCE`;
export const UPDATE_CONSUMER_LEGAL_RESIDENCE_SUCCESS = `${KEY}.UPDATE_CONSUMER_LEGAL_RESIDENCE_SUCCESS`;
export const UPDATE_CONSUMER_LEGAL_RESIDENCE_FAIL = `${KEY}.UPDATE_CONSUMER_LEGAL_RESIDENCE_FAIL`;

export const updateConsumerLegalResidence = (
  payload: types.UpdateConsumerLegalResidencePayload
) => ({
  type: UPDATE_CONSUMER_LEGAL_RESIDENCE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'updateConsumerLegalResidence',
      data: payload
    }
  }
});

export const UPDATE_CONSUMER_PHONE_NUMBER = `${KEY}.UPDATE_CONSUMER_PHONE_NUMBER`;
export const UPDATE_CONSUMER_PHONE_NUMBER_SUCCESS = `${KEY}.UPDATE_CONSUMER_PHONE_NUMBER_SUCCESS`;
export const UPDATE_CONSUMER_PHONE_NUMBER_FAIL = `${KEY}.UPDATE_CONSUMER_PHONE_NUMBER_FAIL`;

export const updateConsumerPhoneNumber = (payload: types.UpdateConsumerPhoneNumber) => ({
  type: UPDATE_CONSUMER_PHONE_NUMBER,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'updateConsumerPhoneNumber',
      data: payload
    }
  }
});

export const REQUEST_PASSWORD_RESET = `${KEY}.REQUEST_PASSWORD_RESET`;
export const REQUEST_PASSWORD_RESET_SUCCESS = `${KEY}.REQUEST_PASSWORD_RESET_SUCCESS`;
export const REQUEST_PASSWORD_RESET_FAIL = `${KEY}.REQUEST_PASSWORD_RESET_FAIL`;

export const requestPasswordReset = (payload: types.RequestPasswordResetPayload) => ({
  type: REQUEST_PASSWORD_RESET,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'requestPasswordReset',
      data: payload
    }
  }
});
